<template>
  <div v-if="allEvents.length || allTasks.length">
    <hr class="mt-2 calendar-hr" />
    <h6 class="text-muted">{{ date.date | moment("ddd DD") }}</h6>

    <ul class="mb-2 list-group text-dark">
      <li v-for="task in allTasks" :key="task.id" class="list-group-item js-task-details-collapse-container">
        <QuickTask :task="task" />
      </li>
      <li v-for="event in allEvents" :key="event.id" class="list-group-item list-group-item-secondary">
        <Event :event="event"/>
      </li>
    </ul>
  </div>
</template>

<script>
import Event from "components/Event";
import QuickTask from "components/QuickTask";
import moment from 'moment';

export default {
  components: {
    Event,
    QuickTask
  },
  computed: {
    allEvents: function(){
      var date = this.date.date

      return this.$store.state.events.filter(function (event){
        if(new Date(event.start).toDateString() == new Date(event.end).toDateString()){
          return new Date(event.start).toDateString() == date.toDateString()
        } else {
          return new Date(event.start).getTime() <= date.getTime() && new Date(event.end).getTime() >= date.getTime()
        }
      })
    },
    allTasks: function(){
      var date = moment(this.date.date).format('YYYY-MM-DD')
      return this.$store.state.tasks.filter(function (task){
        return (task.due_date == date && task.completed === false)
      })
    }
  },
  props: {
    date: {
      type: Object
    }
  }
}
</script>
